import React, { Component } from "react";
import Aux from "../../../../hoc/Auxilliary";
import Question from "../../Learning/Assignment/Question/Question";
import { getMisc } from "../../../../localstorage-service";
class AssessmentQuestions extends Component {
  render() {
    return (
      <Aux>
        <Question
          index={this.props.questionIndex + 1}
          totalquestions={this.props.questions.length}
          key={this.props.currentquestion.Id}
          questionId={this.props.currentquestion.Id}
          videoId={this.props.currentquestion.VideoId}
          subCategoryId={this.props.currentquestion.SubCategoryId}
          questionTypeId={this.props.currentquestion.QuestionTypeId}
          questionText={this.props.currentquestion.QuestionText}
          answers={this.props.currentquestion.answers}
          isAssessmentSubmitted={this.props.isAssessmentSubmitted}
          answerClicked={id => this.props.answerClicked(id)}
          brightcoveVideoId={this.props.currentquestion.BrightcoveVideoId}
          brightcoveAccountId={this.props.currentquestion.BrightcoveAccountId}
        />
        <center>
          {this.props.isLastQuestion && (
            <Aux>
              <hr />
              <button className="btn btn-default pull-right" onClick={this.props.submitAssessmentClicked}>
                {getMisc("submitassessment")}
              </button>
            </Aux>
          )}
          {!this.props.isLastQuestion && (
            <Aux>
              <hr />
              <button className="btn btn-default pull-right" onClick={this.props.nextQuestionClicked}>
                {getMisc("next")}
              </button>
            </Aux>
          )}
        </center>
      </Aux>
    );
  }
}

export default AssessmentQuestions;



// WEBPACK FOOTER //
// ./src/containers/User/Common/VideoMain/AssessmentQuestions.js